/**
 * Transform an object into a JSON response
 */
function createJsonResponse(c, data) {
    return c.json(data);
}

export { createJsonResponse };
